import { useState } from "react";
import * as XLSX from "xlsx";
import { Col, Form, Row } from "react-bootstrap";
import TitlePage from "../../../../components/TitlePage";
import ResponsiveDataTable from "../../../../components/DataTable";
import SubmitForm from "../../../../components/SubmitForm";
import ConsumoTOTVS_POST from "../../../../../backend/ConsumoTotvs";
import { ErroMsg, formatarMoeda2, parseLocaleNumber, SucessoMsg } from "../../../../contents/VariaveisGlobais";
import LoadingSpinner from "../../../../components/LoadinSpinner";

const ImportarProduto = () => {
    const [carregar, setCarregar] = useState(false);
    const [produtos, setProdutos] = useState([]);

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (event) => {
                const binaryStr = event.target.result;
                const workbook = XLSX.read(binaryStr, { type: "binary" });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];

                // Usa a primeira linha como referência para os campos
                const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

                const headers = jsonData[0];  // Primeira linha com os títulos
                const rows = jsonData.slice(1);  // Restante das linhas

                const data = rows.map((row) =>
                    Object.fromEntries(headers.map((header, index) => [header, row[index] || '']))
                );

                const produtosProcessados = processarProdutos(data);
                setProdutos(produtosProcessados);
            };
            
            reader.readAsBinaryString(file);
        }
    };


    const processarProdutos = (data) => {
        setCarregar(true);
        let produtosProcessados = [];

        data.forEach((row) => {
            let valorIPI = 0
            try{
                valorIPI = parseFloat(row["IPI"]) || 0;
            }catch(e){
                valorIPI = 0
            }
            
            produtosProcessados.push({
                B1_COD: row["ITEM_Código"],
                B1_DESC: row["ITEM_Descrição_Resumida_PT-BR"],
                B1_POSIPI: row["NCM/NBS"],
                B1_TIPO: row["ITEM_Tipo_de_Item"],
                B1_UM: row["ITEM_Unidade_Medida"],
                B1_IPI: parseLocaleNumber(formatarMoeda2(valorIPI,2)),
                B1_GRUPO: '' + row["Código Grupo/Subgrupo"],
                BM_DESC: row["Grupos"].trim() + " " + row["Subgrupos"].trim(),
                B5_CEME: row["ITEM_Descrição_Completa_PT-BR"],
                B1_XIDKLAS: row["Iditem"],
                B1_XIDSIN: row["IdSIN"],
                B1_LOCPAD: "F00000"
            });
        });

        setCarregar(false);
        return produtosProcessados;
    };

    const handleSubmit = async() => {
        const cJSON = JSON.stringify(produtos)
        setCarregar(true);
        const oRetorno = await ConsumoTOTVS_POST('PRODUTOKLASSMATT', cJSON)

        if (oRetorno.error === '00'){
            SucessoMsg(oRetorno.description)
            setProdutos([])
        }else{
            ErroMsg(oRetorno.description)
        }
        
        setCarregar(false);        
        
        return false
    }

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="Importação de Produtos" exibirIncluir={false}/>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Selecione a Planilha</Form.Label>
                        <Form.Control
                            type="file" 
                            accept=".csv, .xlsx, .xlsm"
                            onChange={handleFileUpload}
                            />
                    </Form.Group>
                </Col>
            </Row>
            
            { produtos && produtos.length > 0 && 
                <SubmitForm 
                    onEnviar={handleSubmit}
                    labelEnviar="➤ Importar"
                />
            }

            {  produtos && produtos.length > 0 && (
                <ResponsiveDataTable
                    columns={[
                        {
                            Header: 'Código',
                            accessor: 'B1_COD'
                        },
                        {
                            Header: 'Produto',
                            accessor: 'B1_DESC'
                        },
                        {
                            Header: 'UM',
                            accessor: 'B1_UM'
                        },
                        {
                            Header: 'Tipo',
                            accessor: 'B1_TIPO'
                        },
                        {
                            Header: 'NCM',
                            accessor: 'B1_POSIPI'
                        },
                        {
                            Header: 'IPI',
                            accessor: 'B1_IPI'
                        },
                        {
                            Header: 'Grupo',
                            accessor: 'B1_GRUPO'
                        },
                        {
                            Header: 'Desc. Grupo',
                            accessor: 'BM_DESC'
                        },
                        {
                            Header: 'Nome Completo',
                            accessor: 'B5_CEME'
                        },
                        {
                            Header: 'ID Klassmatt',
                            accessor: 'B1_XIDKLAS'
                        },
                        {
                            Header: 'ID SIN',
                            accessor: 'B1_XIDSIN'
                        }
                    ]}
                    data={produtos}
                    habilitaBuscar={false}
                />
            )}

        </>
    );
};

export default ImportarProduto;
